/*
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-08-11 16:45:24
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2022-09-14 14:49:19
 * @FilePath: \ioc_base\src\modules\workShop\const\shopManageTable.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { Dic, Dates } from "$utils";
export const tableOption = function (that) {
  return {
    view: "详情",
    page: true,
    selection: true,
    index: true,
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    align: "left",
    size: "small",
    maxHeight: "100%",
    labelSuffix: ' ：',
    labelWidth: "90px",
    menuAlign: "center",
    searchMenuSpan: 6,
    dialogWidth:"700",
    searchBtn: false,
    emptyText: "暂无数据",
    column: [
      {
        label: "工号",
        prop: "accountNumber",
        search: true,
        clearable: true
      },
      {
        label: "照片",
        prop: "operate",
        viewslot:true,
      },
      {
        label: "姓名",
        prop: "nickName",
        search: true,
        clearable: true
      },
      {
        label: "上岗/下岗",
        prop: "type",
        formatter: (info, value) => {
          if (info.type === "1") {
            return "上岗";
          } else if (info.type === "2") {
            return "下岗";
          } else if (info.type === "3") {
            return "换岗";
          }
        },
        viewFormatter: (info, value) => {
          if (value === "1") {
            return "上岗";
          } else if (value === "2") {
            return "下岗";
          } else if (value === "3") {
            return "换岗";
          }
        }
      },
      {
        label: "工作组",
        prop: "securityWorkGroupName"
      },
      {
        label: "岗位类型",
        prop: "dutyType",
        formatter: (info, value) => {
          if (info.dutyType == "1") {
            return "值班岗";
          }
        },
        viewFormatter: (info, value) => {
          if (value == "1") {
            return "值班岗";
          }
        }
      },
      {
        label: "班次",
        prop: "shifts",
        formatter: (info, value) => {
          if (info.shifts === "1") {
            return "00:00-08:00";
          } else if (info.shifts === "2") {
            return "08:00-16:00";
          } else {
            return "16:00-24:00";
          }
        },
        viewFormatter: (info, value) => {
          if (value === "1") {
            return "00:00-08:00";
          } else if (value === "2") {
            return "08:00-16:00";
          } else {
            return "16:00-24:00";
          }
        }
      },
      {
        label: "值班情况",
        prop: "dutySituation"
      },
      {
        label: "备勤",
        prop: "prepareDuty"
      },

      {
        label: "时间",
        prop: "checkTime",
        viewSpan: 24
      },
      {
        label: "备注",
        prop: "remark",
        viewSpan: 24,
        hide:true,
      }
    ]
  };
};
export default tableOption;
